import { useCallback } from 'react'

import { F0Alert, F0Box, F0Button } from '@factorialco/f0-react'
import { DiscardOutdatedTaskDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { useActivity } from 'modules/core/lib/activities/activity'
import i18n from 'modules/core/lib/i18n'

import {
  TaskCustomComponent,
  TaskDefinition,
  TaskFooterComponent,
} from 'modules/inbox_tasks/lib/abstraction'
import { trackDiscardInboxTask } from 'modules/inbox_tasks/lib/events'
import { DiscardWarningAlert } from 'modules/inbox_tasks/tasks/discard/DiscardWarningAlert'

const DiscardTaskContent: TaskCustomComponent = ({ assigneesTotalCount }) => {
  return (
    <F0Box display="flex" flexDirection="column" gap="lg">
      <F0Alert
        variant="info"
        title={i18n.t('tasks.discard_task.resource_unavailable_title')}
        description={i18n.t('tasks.discard_task.resource_unavailable_description')}
      />
      <DiscardWarningAlert assigneesTotalCount={assigneesTotalCount} />
    </F0Box>
  )
}

const DiscardTaskFooter: TaskFooterComponent = ({ taskId }) => {
  const { closeActivity } = useActivity()

  const [discardTask] = useMutation(DiscardOutdatedTaskDocument, {
    extractorFn: (data) => data.tasksMutations.discardOutdatedTasksInboxTask,
  })

  const handleDiscard = useCallback(() => {
    trackDiscardInboxTask({ category: undefined })
    discardTask({ variables: { taskId } }).then(closeActivity)
  }, [discardTask, taskId, closeActivity])

  return (
    <F0Box display="flex" flexDirection="row" justifyContent="end">
      <F0Button
        label={i18n.t('tasks.mark.as', {
          status: i18n.t('tasks.status.discarded').toLowerCase(),
        })}
        variant="critical"
        onClick={handleDiscard}
      />
    </F0Box>
  )
}

export const DiscardTaskDefinition: TaskDefinition = {
  component: DiscardTaskContent,
  footer: DiscardTaskFooter,
}
